/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_matches = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} replaced`)
};

const es_fr_matches = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} reemplazado`)
};

const de_fr_matches = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} ersetzt`)
};

const nl_fr_matches = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} vervangen`)
};

const fr_fr_matches = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} remplacés`)
};

const it_fr_matches = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} sostituiti`)
};

const pt_br2_fr_matches = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} substituído`)
};

const pt_fr_matches = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} substituído(s)`)
};

const ja_fr_matches = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} 置換済み`)
};

const zh_fr_matches = /** @type {(inputs: { n: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已替换 ${i?.n} 处`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ n: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_matches = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_matches(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_matches", locale)
	if (locale === "en") return en_fr_matches(inputs)
	if (locale === "es") return es_fr_matches(inputs)
	if (locale === "de") return de_fr_matches(inputs)
	if (locale === "nl") return nl_fr_matches(inputs)
	if (locale === "fr") return fr_fr_matches(inputs)
	if (locale === "it") return it_fr_matches(inputs)
	if (locale === "pt-BR") return pt_br2_fr_matches(inputs)
	if (locale === "pt") return pt_fr_matches(inputs)
	if (locale === "ja") return ja_fr_matches(inputs)
	return zh_fr_matches(inputs)
};